/* eslint-disable import/prefer-default-export */

export const COLANDER_GROUPS = {
    NEW: 'hub_new',
    DEFAULT: 'hub_default',
};

export const COLANDER_SLUGS = {
    USED: 'used',
};



// WEBPACK FOOTER //
// ./client/src/constants/colanders.js